import { useTranslation } from "react-i18next";
import { lazy } from 'react';
import { Icon } from '@chakra-ui/react';
import { MdAdminPanelSettings, MdLock } from 'react-icons/md';
import { getLocalizedText } from 'utils/localization';

const PublicForm = lazy(() => import('views/admin/main/public/form'));
const PublicLandingPage = lazy(() => import('views/public/landing'));
const Bubloud2026Landing = lazy(() => import('views/public/landing/Bubloud2026Landing'));
const StorePage = lazy(() => import('views/public/store/StorePage'));
const CheckoutPage = lazy(() => import('views/public/store/CheckoutPage'));
const OrderSuccessPage = lazy(() => import('views/public/store/OrderSuccessPage'));
const PublicReservations = lazy(() => import('views/public/reservations'));
const ObjectManagement = lazy(() => import('views/admin/management/objectmanagement'));
const PageManagement = lazy(() => import('views/admin/management/pagemanagement'));
const UserManagement = lazy(() => import('views/admin/management/usermanagement'));
const ClientManagement = lazy(() => import('views/admin/management/clientmanagement'));
const CompanyManagement = lazy(() => import('views/admin/management/companymanagement'));
const SubscriptionManagement = lazy(() => import('views/admin/management/subscriptionmanagement'));
const AutomationManagement = lazy(() => import('views/admin/management/automationmanagement'));
const MapManagement = lazy(() => import('views/admin/management/mapmanagement'));
const ReservationsManagement = lazy(() => import('views/admin/reservations'));
const Profile = lazy(() => import('views/admin/profile'));
const IntegrationsManagement = lazy(() => import('views/admin/management/integrationsmanagement'));
const BidiReader = lazy(() => import('views/admin/bidireader'));
const AnalyticsTool = lazy(() => import('views/admin/tools/analytics'));
const AnalyticsGlobalTool = lazy(() => import('views/admin/tools/analyticsglobal'));
const PlatformRuntimeTool = lazy(() => import('views/admin/tools/platformruntime'));
const SignInDynamic = lazy(() => import('views/auth/signIn/SignInDynamic'));
const SignUpDynamic = lazy(() => import('views/auth/signUp/SignUpDynamic'));
const EmailVerification = lazy(() => import('views/auth/verification/EmailVerification'));

const routes = [
  //--- Dashboards ---
  // {
  //   name: 'Dashboards',
  //   path: '/dashboards',
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Main Dashboard',
  //       layout: '/admin',
  //       path: '/dashboards/default',
  //       component: <DashboardsDefault />,
  //     },
  //     {
  //       name: 'Car Interface',
  //       layout: '/admin',
  //       path: '/dashboards/car-interface',
  //       component: <DashboardsCarInterface />,
  //     },
  //     {
  //       name: 'Smart Home',
  //       layout: '/admin',
  //       path: '/dashboards/smart-home',
  //       component: <DashboardsSmartHome />,
  //     },
  //     {
  //       name: 'RTL',
  //       layout: '/rtl',
  //       path: '/dashboards/rtl',
  //       component: <DashboardsRTLDefault />,
  //     },
  //   ],
  // },
  // --- NFTs ---
  // {
  //   name: 'NFTs',
  //   path: '/nfts',
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Marketplace',
  //       layout: '/admin',
  //       path: '/nfts/marketplace',
  //       component: <NFTMarketplace />,
  //       secondary: true,
  //     },
  //     {
  //       name: 'Collection',
  //       layout: '/admin',
  //       path: '/nfts/collection',
  //       component: <NFTCollection />,
  //       secondary: true,
  //     },
  //     {
  //       name: 'NFT Page',
  //       layout: '/admin',
  //       path: '/nfts/page',
  //       component: <NFTPage />,
  //       secondary: true,
  //     },
  //     {
  //       name: 'Profile',
  //       layout: '/admin',
  //       path: '/nfts/profile',
  //       component: <NFTProfile />,
  //       secondary: true,
  //     },
  //   ],
  // },
  // --- Main pages ---
  // {
  //    name: 'Main Pages',
  //    path: '/main',
  //    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //    collapse: true,
  //    items: [
  //      {
  //       name: 'PublicForm',
  //       path: '/main/publicform/:clientid/:objectid',
  //       collapse: false,
  //       component: <PublicForm />,
  //      }
  //       name: 'Account',
  //       path: '/main/account',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Billing',
  //           layout: '/admin',
  //           path: '/main/account/billing',
  //           exact: false,
  //           component: <AccountBilling />,
  //         },
  //         {
  //           name: 'Application',
  //           layout: '/admin',
  //           path: '/main/account/application',
  //           exact: false,
  //           component: <AccountApplications />,
  //         },
  //         {
  //           name: 'Invoice',
  //           layout: '/admin',
  //           path: '/main/account/invoice',
  //           exact: false,
  //           component: <AccountInvoice />,
  //         },
  //         {
  //           name: 'Settings',
  //           layout: '/admin',
  //           path: '/main/account/settings',
  //           exact: false,
  //           component: <AccountSettings />,
  //         },
  //         {
  //           name: 'All Courses',
  //           layout: '/admin',
  //           path: '/main/account/all-courses',
  //           exact: false,
  //           component: <AccountAllCourses />,
  //         },
  //         {
  //           name: 'Course Page',
  //           layout: '/admin',
  //           path: '/main/account/course-page',
  //           exact: false,
  //           component: <AccountCoursePage />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Ecommerce',
  //       path: '/main/ecommerce',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'New Product',
  //           layout: '/admin',
  //           path: '/main/ecommerce/new-prodcut',
  //           exact: false,
  //           component: <EcommerceNewProduct />,
  //         },
  //         {
  //           name: 'Product Overview',
  //           layout: '/admin',
  //           path: '/main/ecommerce/product-overview',
  //           exact: false,
  //           component: <EcommerceProductOverview />,
  //         },
  //         {
  //           name: 'Product Settings',
  //           layout: '/admin',
  //           path: '/main/ecommerce/settings',
  //           exact: false,
  //           component: <EcommerceProductSettings />,
  //         },
  //         {
  //           name: 'Product Page',
  //           layout: '/admin',
  //           path: '/main/ecommerce/page-example',
  //           exact: false,
  //           component: <EcommerceProductPage />,
  //         },
  //         {
  //           name: 'Order List',
  //           layout: '/admin',
  //           path: '/main/ecommerce/order-list',
  //           exact: false,
  //           component: <EcommerceOrderList />,
  //         },
  //         {
  //           name: 'Order Details',
  //           layout: '/admin',
  //           path: '/main/ecommerce/order-details',
  //           exact: false,
  //           component: <EcommerceOrderDetails />,
  //         },
  //         {
  //           name: 'Referrals',
  //           layout: '/admin',
  //           path: '/main/ecommerce/referrals',
  //           exact: false,
  //           component: <EcommerceReferrals />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Users',
  //       path: '/main/users',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'New User',
  //           layout: '/admin',
  //           path: '/main/users/new-user',
  //           exact: false,
  //           component: <UserNew />,
  //         },
  //         {
  //           name: 'Users Overview',
  //           layout: '/admin',
  //           path: '/main/users/users-overview',
  //           exact: false,
  //           component: <UsersOverview />,
  //         },
  //         {
  //           name: 'Users Reports',
  //           layout: '/admin',
  //           path: '/main/users/users-reports',
  //           exact: false,
  //           component: <UsersReports />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Applications',
  //       path: '/main/applications',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Kanban',
  //           layout: '/admin',
  //           path: '/main/applications/kanban',
  //           exact: false,
  //           component: <ApplicationsKanban />,
  //         },
  //         {
  //           name: 'Data Tables',
  //           layout: '/admin',
  //           path: '/main/applications/data-tables',
  //           exact: false,
  //           component: <ApplicationsDataTables />,
  //         },
  //         {
  //           name: 'Calendar',
  //           layout: '/admin',
  //           path: '/main/applications/calendar',
  //           exact: false,
  //           component: <ApplicationsCalendar />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Profile',
  //       path: '/main/profile',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Profile Overview',
  //           layout: '/admin',
  //           path: '/main/profile/overview',
  //           exact: false,
  //           component: <ProfileOverview />,
  //         },
  //         {
  //           name: 'Profile Settings',
  //           layout: '/admin',
  //           path: '/main/profile/settings',
  //           exact: false,
  //           component: <ProfileSettings />,
  //         },
  //         {
  //           name: 'News Feed',
  //           layout: '/admin',
  //           path: '/main/profile/newsfeed',
  //           exact: false,
  //           component: <ProfileNewsfeed />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Others',
  //       path: '/main/others',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Notifications',
  //           layout: '/admin',
  //           path: '/main/others/notifications',
  //           exact: false,
  //           component: <OthersNotifications />,
  //         },
  //         {
  //           name: 'Pricing',
  //           layout: '/auth',
  //           path: '/main/others/pricing',
  //           exact: false,
  //           component: <OthersPricing />,
  //         },
  //         {
  //           name: '404',
  //           layout: '/admin',
  //           path: '/main/others/404',
  //           exact: false,
  //           component: <OthersError />,
  //         },
  //         {
  //           name: 'Messages',
  //           layout: '/admin',
  //           path: '/main/others/messages',
  //           exact: false,
  //           component: <Messages />,
  //         },
  //       ],
  //     },
  //    ],
  // },
  //--- Authentication ---
  {
    name: 'Authentication',
    path: '/auth',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    hideInMenu: true,
    collapse: true,
    items: [
      // --- Sign In ---
      {
        name: 'Sign In',
        path: '/sign-in',
        collapse: true,
        items: [
          {
            name: 'Default',
            layout: '/auth',
            path: '/sign-in/',
            component: <SignInDynamic />,
          },
          // {
          //   name: 'Default',
          //   layout: '/auth',
          //   path: '/sign-in/default',
          //   component: <SignInDefault />,
          // },
          // {
          //   name: 'Centered',
          //   layout: '/auth',
          //   path: '/sign-in/centered',
          //   component: <SignInCentered />,
          // },
        ],
      },
      {
        name: 'Forgot Password',
        layout: '/auth',
        path: '/forgot-password',
        component: <SignInDynamic initialMode="passwordRecovery" />,
      },
      // --- Sign Up ---
      {
        name: 'Sign Up',
        path: '/sign-up',
        collapse: true,
        items: [
          // {
          //   name: 'Default',
          //   layout: '/auth',
          //   path: '/sign-up/default',
          //   component: <SignUpDefault />,
          // },
          // {
          //   name: 'Centered',
          //   layout: '/auth',
          //   path: '/sign-up/centered',
          //   component: <SignUpCentered />,
          // },
          {
            name: 'SignUp with Token',
            layout: '/auth',
            path: '/sign-up/:id/:token',
            component: <SignUpDynamic />,
          },
          {
            name: 'SignUp without Token',
            layout: '/auth',
            path: '/sign-up/:id',
            component: <SignUpDynamic />,
          },
        ],
      },
      // --- Verification ---
      {
        name: 'Verification',
        path: '/verification',
        layout: '/auth',
        component: <EmailVerification />,
      },
      // --- Verification (old) ---
      // {
      //   name: 'Verification',
      //   path: '/verification',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Default',
      //       layout: '/auth',
      //       path: '/verification/default',
      //       component: <VerificationDefault />,
      //     },
      //     {
      //       name: 'Centered',
      //       layout: '/auth',
      //       path: '/verification/centered',
      //       component: <VerificationCentered />,
      //     },
      //   ],
      // },
      // // --- Lock ---
      // {
      //   name: 'Lock',
      //   path: '/lock',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Default',
      //       layout: '/auth',
      //       path: '/lock/default',
      //       component: <LockDefault />,
      //     },
      //     {
      //       name: 'Centered',
      //       layout: '/auth',
      //       path: '/lock/centered',
      //       component: <LockCentered />,
      //     },
      //   ],
      // },
      // // --- Forgot Password ---
      // {
      //   name: 'Forgot Password',
      //   path: '/forgot-password',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Default',
      //       layout: '/auth',
      //       path: '/forgot-password/default',
      //       component: <ForgotPasswordDefault />,
      //     },
      //     {
      //       name: 'Centered',
      //       layout: '/auth',
      //       path: '/forgot-password/centered',
      //       component: <ForgotPasswordCentered />,
      //     },
      //   ],
      // },
    ],
  },
];

export default routes;
  export const useRoutesOrgSaas = () => {
    const { t, i18n } = useTranslation();
    const integrationsLabel = getLocalizedText(
      {
        es: 'Integraciones',
        en: 'Integrations',
        fr: 'Integrations',
        pt: 'Integracoes',
        it: 'Integrazioni',
        de: 'Integrationen',
      },
      'Integrations',
      i18n.language
    );

    const routesOrgSaas: RoutesType[] = [
      {
        name: t("Admin"),
        path: "/dashboards",
        icon: <Icon as={MdAdminPanelSettings} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: t("Object Management"),
            layout: "/admin",
            path: "/management/objectmanagement",
            component: <ObjectManagement />,
            permission: "ObjectManagement",
          },
          {
            name: t("Page Management"),
            layout: "/admin",
            path: "/management/pagemanagement",
            component: <PageManagement />,
            permission: "DashboardManagement",
          },
          {
            name: t("Gestion de usuarios"),
            title: t("Gestion de usuarios"),
            layout: "/admin",
            path: "/management/usermanagement",
            component: <UserManagement />,
            permission: "UserManagement",
          },
          {
            name: t("Client Management"),
            layout: "/admin",
            path: "/management/clientmanagement",
            component: <ClientManagement />,
            permission: "ClientManagement",
          },
          {
            name: t("Company Management"),
            layout: "/admin",
            path: "/management/companymanagement",
            component: <CompanyManagement />,
            permission: "CompanyManagement",
          },
          {
            name: t("Gestion de cobros"),
            title: t("Gestion de cobros"),
            layout: "/admin",
            path: "/management/subscriptionmanagement",
            component: <SubscriptionManagement />,
            permission: "SubscriptionsManagement",
          },
          {
            name: t("Automation Management"),
            layout: "/admin",
            path: "/management/automationmanagement",
            component: <AutomationManagement />,
            permission: "AutomationManagement",
          },
          {
            name: t("Gestion de planos"),
            title: t("Gestion de planos"),
            layout: "/admin",
            path: "/management/mapmanagement",
            component: <MapManagement />,
            permission: "MapManagement",
            hideInMenu: true,
          },
          {
            name: t("Gestion de reservas"),
            title: t("Gestion de reservas"),
            layout: "/admin",
            path: "/management/reservations",
            component: <ReservationsManagement />,
            permission: "ReservationManagement",
            hideInMenu: true,
          },
        ],
      },
      {
        name: t("Profile"),
        layout: "/admin",
        path: "/profile",
        component: <Profile />,
        hideInMenu: true, // No mostrar en el menú lateral, solo accesible desde el menú del Avatar
      },
      {
        name: integrationsLabel,
        title: integrationsLabel,
        layout: "/tools",
        path: "/integrations",
        component: <IntegrationsManagement />,
        permission: "IntegrationsManagement",
        hideInMenu: true,
      },
      {
        name: t("BidiReader"),
        title: t("BidiReader"),
        layout: "/tools",
        path: "/bidireader",
        component: <BidiReader />,
        hideInMenu: true,
      },
      {
        name: integrationsLabel,
        title: integrationsLabel,
        layout: "/admin",
        path: "/management/integrationsmanagement",
        component: <IntegrationsManagement />,
        permission: "IntegrationsManagement",
        hideInMenu: true,
      },
      {
        name: t("Analytics"),
        title: t("Analytics"),
        layout: "/tools",
        path: "/analytics",
        component: <AnalyticsTool />,
        permission: "AnalyticsManagement",
        hideInMenu: true,
      },
      {
        name: t("Analytics Global"),
        title: t("Analytics Global"),
        layout: "/tools",
        path: "/analytics-global",
        component: <AnalyticsGlobalTool />,
        permission: "AnalyticsGlobalView",
        hideInMenu: true,
      },
      {
        name: t("Gestión de eventos"),
        title: t("Gestión de eventos"),
        layout: "/tools",
        path: "/events",
        component: <PlatformRuntimeTool mode="events" />,
        permission: "EventManagement",
        hideInMenu: true,
      },
      {
        name: t("Gestión de lógica"),
        title: t("Gestión de lógica"),
        layout: "/tools",
        path: "/logic",
        component: <PlatformRuntimeTool mode="logic" />,
        permission: "LogicManagement",
        hideInMenu: true,
      },
      {
        name: t("Modelo de puntuación"),
        title: t("Modelo de puntuación"),
        layout: "/tools",
        path: "/score-model",
        component: <PlatformRuntimeTool mode="score" />,
        permission: "ScoreModelManagement",
        hideInMenu: true,
      },
      {
        name: t("Matriz de permisos"),
        title: t("Matriz de permisos"),
        layout: "/tools",
        path: "/permissions",
        component: <PlatformRuntimeTool mode="permissions" />,
        permission: "PermissionMatrix",
        hideInMenu: true,
      },
    ];

  return routesOrgSaas;
};

const publicRoutes = [
  {
    name: 'PublicFormToken',
    layout: '/public',
    path: 'form/:token',  // Formato: /public/form/{tokenCodificado} - DEBE IR PRIMERO para que coincida antes que la ruta con dos parámetros
    component: <PublicForm />,
    hideInMenu: true,
    title: ''
  },
  {
    name: 'PublicForm',
    layout: '/public',
    path: 'form/:clientid/:objectid/:token?',  // Formato: /public/form/{clientId}/{objectId}?u={qrUserId}
    component: <PublicForm />,
    hideInMenu: true,
    title: ''
  },
  {
    name: 'PublicLanding',
    layout: '/public',
    path: 'landing',
    component: <PublicLandingPage />,
    hideInMenu: true,
    title: ''
  },
  {
    name: 'BubloudLanding2026',
    layout: '/public',
    path: 'landing/bubloud-2026',
    component: <Bubloud2026Landing />,
    hideInMenu: true,
    title: ''
  },
  {
    name: 'Store',
    layout: '/public',
    path: 'store/:clientId?',
    component: <StorePage />,
    hideInMenu: true,
    title: ''
  },
  {
    name: 'StoreCheckout',
    layout: '/public',
    path: 'store/checkout',
    component: <CheckoutPage />,
    hideInMenu: true,
    title: ''
  },
  {
    name: 'OrderSuccess',
    layout: '/public',
    path: 'store/order-success',
    component: <OrderSuccessPage />,
    hideInMenu: true,
    title: ''
  },
  {
    name: 'PublicReservations',
    layout: '/public',
    path: 'reservations/:clientId?',
    component: <PublicReservations />,
    hideInMenu: true,
    title: ''
  },
  // otras rutas públicas aquí...
];

export { publicRoutes };
